import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import { Global } from 'src/app/core/resources/global';
import { ManualCreationCargoService } from 'src/app/modules/cargo/manual-creation-cargo/manual-creation-cargo.service';
import { Utils } from 'src/app/core/resources/utils';
import { Router } from '@angular/router';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { isEmpty } from 'rxjs/operators';
import { DateFormatPipe } from 'src/app/core/pipe/dateFormat.pipe';
import haversine from "haversine-distance";
import { UploadService } from './upload.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { Fmt } from 'src/app/core/messages/fmt';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { Patterns } from 'src/app/core/resources/patterns';
import { AddressCargo } from 'src/app/core/interfaces/addressCargo';
import { DateManager } from 'src/app/core/managers/date.manager';
import { GoogleService } from 'src/app/core/services/google.service';
import { CargoFeature } from 'src/app/core/interfaces/cargoFeature';

@Component({
  selector: 'app-upload-freight',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
  providers: [AuthService, Global]
})

export class UploadComponent implements OnInit {
  stimated_time: any;
  timeList: Array<{ title: string, value: string }> = [];
  minLengthCellphone: number = 9;
  maxLengthCellphone: number = 12;
  hourList: Array<{ title: string, value: number }> = [];
  minuteList: Array<{ title: string, value: number }> = [];
  minTimePact: number = 1;
  hourOptionsByAddress: Array<Array<{ value: number, title: string }>> = [];
  minuteOptionsByAddress: Array<Array<{ value: number, title: string }>> = [];
  constructor(
    public UploadService: UploadService,
    public manualCreationCargoService: ManualCreationCargoService,
    public snackBarService: SnackBarService,
    public utils: Utils,
    private router: Router,
    private fb: FormBuilder,
    private patterns: Patterns,
    private googleService: GoogleService,
    private authService: AuthService
  ) {
    this.timeList = this.utils.getListTime();
    this.hourList = this.utils.getListHour();
    this.minuteList = this.utils.getListMinute();
  }

  ngOnInit() {
    this.setValidatorsUpload();
  }

  setValidatorsUpload() {
    this.addresses.forEach((address, index) => {
      if (this.utils.isTeclogiUserOrClient) {
        if (this.utils.isEmptyTeclogiTimePact(address.get('timePact').value, address.get('minutePact').value)) {
          const def = this.utils.getTeclogiDefaultTimePact();
          address.get('timePact').setValue(def.hours);
          address.get('minutePact').setValue(def.minutes);
        }
      } else {
        address.get('timePact').setValidators(Validators.min(this.minTimePact));
        !address.get('timePact').value && address.get('timePact').setValue(this.minTimePact);
      }
      address.get('time').setValidators(Validators.required);
      address.get('cellphone').setValidators([Validators.minLength(this.minLengthCellphone), Validators.maxLength(this.maxLengthCellphone), Validators.pattern(this.patterns.CELLPHONEANDLANDLINE.source)]);
      this.setTimePactOptions(index, address);
    })
  }

  /**
   * Precomputa las opciones de tiempo pactado (horas/minutos) por dirección y las guarda
   * como referencias estables. Evita generar arreglos nuevos en cada ciclo de change
   * detection desde el template (lo que provocaba un bucle infinito con mat-select).
   */
  private setTimePactOptions(index: number, address: AbstractControl) {
    if (!address) return;
    const hours = address.get('timePact').value;
    const minutes = address.get('minutePact').value;
    this.hourOptionsByAddress[index] = this.utils.getTimePactHourList(this.utils.isTeclogiUserOrClient, this.hourList, hours);
    this.minuteOptionsByAddress[index] = this.utils.getTimePactMinuteList(this.utils.isTeclogiUserOrClient, hours, this.minuteList, minutes);
  }

  get addresses(): FormGroup[] {
    return (this.manualCreationCargoService.cargoForm.get('cargoFeature.uploadDownload.origin.addresses') as FormArray).controls as FormGroup[];
  }

  get addressCity(): string {
    return this.manualCreationCargoService.cargoForm.get('cargoFeature.uploadDownload.origin.name').value;
  }

  get addressesDst() {
    return (this.manualCreationCargoService.cargoForm.get('cargoFeature.uploadDownload.destination') as FormArray).controls;
  }

  onSelectTime($event: MatButtonToggleChange, key: string, index: number) {
    this.manualCreationCargoService.getAddressGroupActive(index).get(key).setValue($event.value);
    if (this.utils.isTeclogiUserOrClient && key === 'timePact') {
      const minuteCtrl = this.manualCreationCargoService.getAddressGroupActive(index).get('minutePact');
      if (Number($event.value) === 1) minuteCtrl.setValue(0);
      else if (Number($event.value) === 0 && !(Number(minuteCtrl.value) > 0)) minuteCtrl.setValue(5);
    }
    if (key === 'timePact' || key === 'minutePact') this.setTimePactOptions(index, this.addresses[index]);
    const addressControl = this.getAddressGroupActive(index);
    const address: AddressCargo = addressControl.value;
    this.normalize(index);
    this.manualCreationCargoService.estimatedTimesOrigin[index] = false;
    //check next address if exists
    const addresses: AddressCargo[] = this.getAddresses();
    const currentIndex: number = addresses.findIndex(addressIn => addressIn.location.lat === address.location.lat && addressIn.location.lng === address.location.lng);
    if (currentIndex !== -1) {
      if (addresses && addresses[currentIndex + 1] && addresses[currentIndex + 1].time) {
        this.normalize(Number(addresses[currentIndex + 1].id));
        this.manualCreationCargoService.estimatedTimesOrigin[Number(addresses[currentIndex + 1].id)] = false;
      }
    }
  }

  private getAddressGroupActive(index: number): AbstractControl {
    let ctrl: AbstractControl;
    if (index >= 0) ctrl = this.manualCreationCargoService.cargoForm.get(`cargoFeature.uploadDownload.origin.addresses.${index}`);
    return ctrl;
  }

  onKeyUp($event: any, key: string, index: number) {
    this.manualCreationCargoService.getAddressGroupActive(index).get(key).setValue(
      $event.target.value
    );
  }

  findErrorOnOrigin() {
    let haveErrors = false;
    for (let [i, address] of this.addresses.entries()) {
      if (!haveErrors) {
        if (this.utils.errorMessagesCustomized(address.get('time'), `hora de cargue de la dirección ${i + 1}`)) {
          haveErrors = true;
          break;
        }
        else if (this.utils.errorMessagesCustomized(address.get('cellphone'), `celular de la dirección ${i + 1}`, this.minLengthCellphone, this.maxLengthCellphone)) {
          haveErrors = true;
          break;
        }
      } else break;
    }
    return haveErrors;
  }

  getAddresses(): Array<AddressCargo> {
    let addressesMod = this.utils.clone(this.manualCreationCargoService.cargoForm.controls.cargoFeature['controls'].uploadDownload.get('origin.addresses').value);
    addressesMod.forEach((address: AddressCargo, index: number) => {
      address['date'] = this.dateLoad;
      address['id'] = index.toString();
    })
    return addressesMod;
  }

  public normalize(iAddress: number) {
    if (this.manualCreationCargoService.estimatedTimesOrigin[iAddress] === undefined) this.manualCreationCargoService.estimatedTimesOrigin[iAddress] = false;
  }

  async nextStep() {
    this.addresses.forEach(address => address.markAllAsTouched());

    const isValidDates = await this.manualCreationCargoService.isValidAllDateTimeLoad();


    if (this.manualCreationCargoService.isValidUploadAddressesAdditionalData() && isValidDates) {
      // cargue
      this.manualCreationCargoService.getComponentActive().setId(3);
      this.manualCreationCargoService.getComponentActive().getStep().setId(2);
      this.router.navigate([this.manualCreationCargoService.steps.download.url]);
    }
    else {
      if (!this.manualCreationCargoService.isValidUploadAddressesAdditionalData()) {
        if (!this.findErrorOnOrigin()) this.snackBarService.openSnackBar(FormMessages.GENERAL_ERROR_DEFAULT, undefined, 'error');
      }
      else this.snackBarService.openSnackBar(Fmt.string(FormMessages.TIME_INVALID2, 'cargue'), undefined, 'alert');
    }
  }

  stepBack() {
    this.manualCreationCargoService.getComponentActive().setId(2);
    this.manualCreationCargoService.getComponentActive().getStep().setId(6);
    this.router.navigate([this.manualCreationCargoService.steps.sizeLoad.url]);
  }



  //GETTERS
  private get dateLoad(): string {
    return this.manualCreationCargoService.cargoForm.value.dateLoad;
  }

  getPreviosAddTime(index: number): string {
    let addresses: AddressCargo[] = this.getAddresses();
    if (index >= 0 && addresses && addresses.length && addresses[index] && addresses[index - 1]) return addresses[index - 1].time;
    return '';
  }

  trackByOptionValue(_index: number, option: { value: number, title: string }): number {
    return option.value;
  }

}
